export default __webpack_public_path__ + "static/media/star-half-alt-solid.8f59757b.svg";